import { grey } from "@mui/material/colors";
import { Text } from "@react-pdf/renderer";
import { useMemo } from "react";
import PdfSection from "../layout/PdfSection";
import PdfLabel from "../typography/PdfLabel";
import PdfColumn from "../layout/PdfColumn";
import PdfGrid from "../layout/PdfGrid";

const PdfTable = ({ title, columnDefs = [], rowData = [], gap = 1, style }) => {
  if (!columnDefs.length || !rowData.length) return null;

  return (
    <PdfSection>
      {title && <PdfLabel bold={false}>{title}</PdfLabel>}
      <PdfColumn
        gap={0}
        style={{
          marginTop: 5,
          border: "1px solid #ccc",
          padding: 2,
          borderRadius: 4,
        }}
      >
        <PdfTableRow header>
          {columnDefs.map((col, index) => (
            <PdfTableCell key={index}>{col.headerName}</PdfTableCell>
          ))}
        </PdfTableRow>

        {rowData.map((row, rowIndex) => (
          <PdfTableRow key={rowIndex}>
            {columnDefs.map((col, colIndex) => (
              <PdfTableCell key={colIndex}>
                {row[col.field] !== undefined ? row[col.field] : ""}
              </PdfTableCell>
            ))}
          </PdfTableRow>
        ))}
      </PdfColumn>
    </PdfSection>
  );
};

const PdfTableRow = ({ header, children }) => {
  const styles = useMemo(() => {
    return {
      flexDirection: "row",
      borderBottomWidth: 1,
      borderBottomColor: "#eeeeee",
      ...(header && {
        backgroundColor: grey[200],
        fontWeight: "bold",
      }),
    };
  }, [header]);

  return (
    <PdfGrid columns={2} style={styles}>
      {children}
    </PdfGrid>
  );
};

const PdfTableCell = ({ children }) => {
  const styles = useMemo(() => {
    return {
      fontSize: 8,
      padding: 4,
    };
  }, []);

  return <Text style={styles}>{children}</Text>;
};

export default PdfTable;
